module.exports = __webpack_public_path__ + "static/media/errorShield.47fffd60.svg";